// Push events to Google Tag Manager dataLayer
declare global {
  interface Window {
    dataLayer?: Array<Record<string, unknown>>;
  }
}

export function trackEvent(event: string, data?: Record<string, unknown>) {
  window.dataLayer?.push({ event, ...data });
}

// Pre-defined events
export const analytics = {
  // Wizard steps
  stepComplete: (step: number) => trackEvent('step_complete', { step }),

  // Generation
  generateStart: (mode: string) => trackEvent('generate_start', { mode }),
  generateComplete: (mode: string) => trackEvent('generate_complete', { mode }),

  // Templates
  templateSelect: (template: string) => trackEvent('template_select', { template }),
  vibeGenerate: (vibe: string) => trackEvent('vibe_generate', { vibe }),

  // Export
  exportPdf: () => trackEvent('export_pdf'),
  exportWord: () => trackEvent('export_word'),
  exportCopy: () => trackEvent('export_copy'),

  // Share
  shareClick: (platform: string) => trackEvent('share_click', { platform }),
  shareCopyLink: () => trackEvent('share_copy_link'),

  // Auth
  signupStart: () => trackEvent('signup_start'),
  signupComplete: (source?: string) => trackEvent('signup_complete', { source }),
  login: () => trackEvent('login'),

  // Resumes
  resumeSave: () => trackEvent('resume_save'),
  resumeLoad: () => trackEvent('resume_load'),
  resumeDelete: () => trackEvent('resume_delete'),

  // Tokens
  checkoutStart: (priceId: string) => trackEvent('checkout_start', { price_id: priceId }),
  purchaseComplete: () => trackEvent('purchase_complete'),

  // Landing page
  ctaClick: (location: string) => trackEvent('cta_click', { location }),
  pricingView: () => trackEvent('pricing_view'),

  // Guided mobile onboarding
  guidedStart: () => trackEvent('guided_start'),
  guidedStepView: (scene: string) => trackEvent('guided_step_view', { scene }),
  guidedComplete: () => trackEvent('guided_complete'),
  guidedSkip: (scene: string) => trackEvent('guided_skip', { scene }),
  /** Answered the fact guard's questions instead of letting claims be removed. */
  evidenceAnswered: (count: number) => trackEvent('evidence_answered', { count }),
  evidenceSkipped: (count: number) => trackEvent('evidence_skipped', { count }),
};
